import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'

import { App } from './App'
import { FallbackComponent } from './components'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (import.meta.env.VITE_APP_ENV === 'production') {
  Sentry.init({
    dsn: 'https://64ee54c05634964c4a2a4749ad3c0eda@sentry.devebs.net/159',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_ENV || 'production'
  })
}

root.render(
  <HelmetProvider>
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <App />
    </Sentry.ErrorBoundary>
  </HelmetProvider>
)
